import { makeQueryOptions } from '@mint-lib/api-zod-support/react-query';

import { defaultApi } from '@mint-sdk/api-core';
import { z } from 'zod';

import {
  AppsFlyerIntegrationCreationSchema,
  AppsFlyerIntegrationSchema,
  AppsFlyerResponseSchema,
} from '../shared/schemas/AppsFlyerSchema.js';
import { OmniTraffickingIntegrationResponseSchema } from '../shared/schemas/OmniTraffickingIntegrationsResponseSchema.js';

export const getAppsFlyerIntegrations = defaultApi.declareEndpoint({
  url: 'appsflyer/v1/integrations/' as const,
  method: 'GET',
  responseSchema: AppsFlyerResponseSchema,
});

export const getQueryOptions = makeQueryOptions(getAppsFlyerIntegrations, {
  processResponse(data) {
    return data?.data;
  },
});

export const createAppsFlyerIntegration = defaultApi.declareEndpoint({
  url: 'appsflyer/v1/integrations/' as const,
  method: 'POST',
  requestSchema: AppsFlyerIntegrationCreationSchema,
  responseSchema: AppsFlyerResponseSchema,
});

export const deleteAppsFlyerIntegration = defaultApi.declareEndpoint({
  url: 'appsflyer/v1/integrations/$integrationId/' as const,
  method: 'DELETE',
  responseSchema: z.object({}),
});

export const updateAppsFlyerIntegration = defaultApi.declareEndpoint({
  url: 'appsflyer/v1/integrations/$integrationId/' as const,
  method: 'PATCH',
  requestSchema: AppsFlyerIntegrationCreationSchema,
  responseSchema: AppsFlyerResponseSchema,
});

export const getOmniTraffickingAppsFlyerIntegrations =
  defaultApi.declareEndpoint({
    url: 'omni-trafficking/v1/integrations/?ad_server=appsflyer_ad_server' as const,
    method: 'GET',
    responseSchema: OmniTraffickingIntegrationResponseSchema,
  });

export const getOmniTraffickingQueryOptions = makeQueryOptions(
  getOmniTraffickingAppsFlyerIntegrations,
  {
    processResponse(data) {
      return data?.data;
    },
  },
);

export const createOmniTraffickingAppsFlyerIntegration =
  defaultApi.declareEndpoint({
    url: 'omni-trafficking/v1/integrations/appsflyer/' as const,
    method: 'POST',
    requestSchema: AppsFlyerIntegrationCreationSchema,
    responseSchema: OmniTraffickingIntegrationResponseSchema,
  });

export const deleteOmniTraffickingAppsFlyerIntegration =
  defaultApi.declareEndpoint({
    url: 'omni-trafficking/v1/integrations/$integrationId/' as const,
    method: 'DELETE',
    responseSchema: z.object({}),
  });

export const updateOmniTraffickingAppsFlyerIntegration =
  defaultApi.declareEndpoint({
    url: 'omni-trafficking/v1/integrations/appsflyer/$integrationId/' as const,
    method: 'PATCH',
    requestSchema: AppsFlyerIntegrationCreationSchema,
    responseSchema: OmniTraffickingIntegrationResponseSchema,
  });

export type AppsFlyerIntegrationType = z.infer<
  typeof AppsFlyerIntegrationSchema
>;

export type AppsFlyerIntegrationCreationType = z.infer<
  typeof AppsFlyerIntegrationCreationSchema
>;

export type AppsFlyerResponseType = z.infer<typeof AppsFlyerResponseSchema>;
